import { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { getLicenseStatus, type LicenseStatus } from '../api/license';

// ============================================================
// H2：私有化只读横幅（授权过期且宽限期结束后）
// - SaaS 模式 / 未过期：不渲染
// - 宽限期内（grace/missing）：黄色提醒（仍可写）
// - 只读（expired/invalid 超宽限）：红色横幅
// ============================================================
export default function LicenseBanner() {
  const [status, setStatus] = useState<LicenseStatus | null>(null);

  useEffect(() => {
    let alive = true;
    getLicenseStatus().then((s) => {
      if (alive) setStatus(s);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!status || status.mode !== 'private' || status.status === 'valid' || status.status === 'not-required') return null;

  const type = status.readonly ? 'error' : 'warning';
  const head = status.readonly ? '授权已过期（只读模式）' : '授权提示';
  const detail = status.reason ?? (status.readonly ? '请联系服务商续期后恢复编辑' : '请在宽限期内放置授权文件');
  const until = status.graceEndsAt ? `｜宽限截止：${new Date(status.graceEndsAt).toLocaleString()}` : '';

  return (
    <div data-testid="license-banner" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000 }}>
      <Alert banner type={type} message={`${head}：${detail}${until}`} showIcon />
    </div>
  );
}
